import { render, staticRenderFns } from "./SetComponent.vue?vue&type=template&id=10c457ae"
import script from "./SetComponent.vue?vue&type=script&lang=js"
export * from "./SetComponent.vue?vue&type=script&lang=js"
import style0 from "./SetComponent.vue?vue&type=style&index=0&id=10c457ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports